// Pages
export { default as ContactsDashboard } from './pages/ContactsDashboard';

// Components
export { default as ContactListSidebar } from './components/ContactListSidebar';
export { default as ContactsTable } from './components/ContactsTable';
export { default as ContactsTableSkeleton } from './components/ContactsTableSkeleton';
export { default as ContactsHeader } from './components/ContactsHeader';
export { default as CreateListDialog } from './components/CreateListDialog';
export { default as DeleteListDialog } from './components/DeleteListDialog';
export { default as EditContactDialog } from './components/EditContactDialog';
export { default as DeleteContactDialog } from './components/DeleteContactDialog';
export { default as UploadCsvCard } from './components/UploadCsvCard';

// Hooks
export { default as useContactsApi } from './hooks/useContactsApi';
export { default as useContactsViewModel } from './hooks/useContactsViewModel';

// Types
export type {
  ApiError,
  ApiResponse,
  ContactListDto,
  CreateContactListDto,
  ContactInfoDto,
  UpdateContactDto,
  ListSource,
  ContactStatus,
  ContactsTab,
  FiltersState,
} from './types/contacts.types';

export {
  DEFAULT_FILTERS,
  statusFromDto,
  tabToSource,
} from './types/contacts.types';
